import Sidebar from "./Sidebar";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen text-white relative">
      <Sidebar />
      <main className="ml-64 min-h-screen">
        <div className="px-8 md:px-12 py-10 max-w-[1400px]">
          {children}
        </div>
      </main>
    </div>
  );
}

export function PageHeader({ overline, title, subtitle, actions, testId }) {
  return (
    <header className="mb-10 flex items-end justify-between gap-6" data-testid={testId}>
      <div>
        {overline && <div className="overline mb-3">{overline}</div>}
        <h1 className="font-display font-bold text-4xl md:text-5xl tracking-tight leading-none">
          {title}
        </h1>
        {subtitle && <p className="mt-3 text-zinc-400 text-base max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-3">{actions}</div>}
    </header>
  );
}

export function Card({ children, className = "", testId, ...rest }) {
  return (
    <div
      data-testid={testId}
      className={`glass rounded-2xl ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
